export default __webpack_public_path__ + "static/media/google_icon.8d59ad6c.png";